Hop.defineModule('alert-unverified-brief-modal', (root, params) => {
    const openBriefBtn = root.querySelector('#open-brief-btn');
    const modal = root.querySelector('#AlertUnverifiedBriefModal');
    const redirect = params.url;

    async function submitChoice() {
        const showMeAgain = root.querySelector('#show-again-checkbox');
        if (showMeAgain.checked) {
            await acknowledge(true);
        }
    }

    function redirectToBrief() {
        submitChoice()
            // ensure the redirection is always made
            .finally(() => (window.location = redirect));
    }

    function acknowledge(discard) {
        let endpoint = '/api/webpref/brief-draft-reminder-acknowledgement';
        if (discard) {
            endpoint += '?discard=true';
        }
        return Hop.post(endpoint);
    }

    function setListener() {
        $(modal).on('hidden.bs.modal', submitChoice);
        openBriefBtn.addEventListener('click', redirectToBrief);
    }

    function init() {
        $(modal).modal('show');
        setListener();

        acknowledge(false);
    }

    init();

    return function destroy() {
        $(modal).off('hidden.bs.modal', submitChoice);
        openBriefBtn.removeEventListener('click', redirectToBrief);
    };
});
